module.exports = __webpack_public_path__ + "img/4.a3727739.png";